import React from 'react';
import Button from './Button';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <div className="relative min-h-screen bg-gradient-to-br from-black to-gray-900 flex items-center justify-center text-center px-4">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40 z-0"
        style={{ 
          backgroundImage: "url('https://images.pexels.com/photos/1229356/pexels-photo-1229356.jpeg?auto=compress&cs=tinysrgb&w=1600')",
          backgroundPosition: "center"
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80 z-10"></div>
      
      {/* Content */}
      <div className="relative z-20 max-w-5xl mx-auto">
        <h1 
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold text-white tracking-wider leading-tight mb-6 animate-zoom-in opacity-5 text-glow"
          style={{ animationDelay: "0s" }}
        >
          THE ULTIMATE ONLINE<br />PERSONAL TRAINING PLANS
        </h1>
        
        <p 
          className="text-xl sm:text-2xl text-gray-300 font-light mb-12 tracking-wide animate-zoom-in opacity-0"
          style={{ animationDelay: "0.3s" }}
        >
          The trainer that will change your life
        </p>
        
        <div 
          className="relative inline-block animate-zoom-in opacity-0"
          style={{ animationDelay: "0.6s" }}
        >
          <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-red-600"></div>
          <Link to="/contact">
            <Button>CHANGE YOUR LIFE WITH KELVIN</Button>
          </Link>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex flex-col items-center">
        <span className="text-white text-sm mb-2">Scroll to explore</span>
        <div className="w-1 h-8 bg-gradient-to-b from-red-500 to-transparent rounded-full animate-pulse"></div>
      </div>
    </div>
  );
};

export default Hero;